import React from 'react';
import '../../../Components/Common/typography.css';
import { CompanyEvent } from '../../../types/companyevent.type';
import { StartQualifier } from '../../../utils/type';
import { formatListDate } from '../../../helpers/date';
import { getEventTypeLabel } from '../helpers/eventMapping';

interface EventListItemProps {
  event: CompanyEvent;
  isSelected: boolean;
  onClick: (event: CompanyEvent) => void;
}

const EventListItem: React.FC<EventListItemProps> = ({
  event,
  isSelected,
  onClick,
}) => (
  <div
    className={`event-item${isSelected ? ' event-item-selected' : ''}`}
    onClick={() => onClick(event)}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => e.key === 'Enter' && onClick(event)}
  >
    <span className="event-item-type body-s-regular">
      {getEventTypeLabel(event.eventType)}
    </span>
    <span className="event-item-description body-m-regular">
      {event.eventName}
    </span>
    <span className="event-item-date body-s-regular">
      {formatListDate(
        event.startDate,
        event.startQualifier !== StartQualifier.DateOnly,
      )}
    </span>
  </div>
);

export default EventListItem;
